import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const ProductionCapacityHoc = (Component) => {

  const ProductionCapacityField = ({
    onChange,
    ...remaining
  }) => {

    const handleChange = (e) => {
      const text = e.target.value

      if (text && !isNaN(text)) {
        let value = parseInt(text);
        const productionCapacity = window.productionCapacity;
        if (!productionCapacity || productionCapacity <= 0) {
          return;
        }

        if (value > productionCapacity) {
          value = productionCapacity;
        }
        e.target.value = String(value);
      }
      onChange && onChange(e);
    }

    return (
      <Component
        {...remaining}
        onChange={handleChange}
      />
    )
  }

  ProductionCapacityField.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
  }

  return ProductionCapacityField;
}

export default ProductionCapacityHoc;
